import React from "react";
//import { NavLink } from "react-router-dom";
import './climb.css';
import fotoa from '../images/climb/_DSC_0001a.JPG'
import fotob from '../images/climb/proa_roraima_114.jpg'
import fotoc from '../images/climb/proa_113.jpg'
import fotod from '../images/climb/proa_109.jpg'

const Climb = () => {
  return(
    <div className="bg-white">
      
      <main className="h-100 d-md-inline-block">
          <div className="heroClimb h-100 text-light d-md-inline-block">
            <h1>Tirika</h1>
            <p>We are climbers!</p>
            <img alt="" src={require('../images/climb/DSC_0059a.JPG')} />
          </div>
        </main>

        <div className="text-dark col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-2 m-0 fontResponsive">
          <div className="">
            {/*<h2 className="card-title text-center">High Performance Expeditions</h2>*/}
            <h5 className="card-title text-left">
            In Venezuela, there is a wide range of possibilities for climbers. From big walls, trad and sports multi-pitch routes and deep water soloing to high quality boulder spots. There is no doubt that is in the Tepuis where the most spectacular climbs of these lands remain. Sandstone walls that could get as high as 1000m and perfect boulder problems treasured by the global community of climbers.
            <br/><br/>
            
            
            Tepuys have inspired many things. From incredible stories to unthinkable expeditions. Many of them still remain unclimbed. 
            <br/><br/>
            

	     Emblematic climbers from around the world have visited these amazing sandstone walls, opening outstanding world class big wall routes.
            <br/><br/></h5>
          </div>
        </div>

        <div className="container">
                                                                  
            <div id="carouselExampleControls" className="carousel slide" data-ride="carousel">

                <div className="carousel-inner">
                    
                    <div className="carousel-item active">
                      <img className="d-block w-100" src={fotoa} alt=""/>
                      <div class="carousel-caption d-md-block text-light subheroClimb-a">
                        <h3 class="font-weight-bold text-left">Amurí - Big Wall</h3>
                        <p class="text-left">One of the longest overhangs in the world</p>
                      </div>
                    </div>
                    
                    <div className="carousel-item">
                      <img className="d-block w-100" src={fotob} alt=""/>
                      <div class="carousel-caption d-md-block text-dark subheroClimb-b">
                        <h3 class="font-weight-bold text-left">Roraima Tepuy</h3>
                      </div>
                    </div>
                    
                    <div className="carousel-item">
                      <img className="d-block w-100" src={fotoc} alt=""/>
                      <div class="carousel-caption d-md-block text-light subheroClimb-c">
                        <h3 class="font-weight-bold text-left">Big Wall in Roraima</h3>
                        <p class="text-left">600 m of incredible sandstone. Route: Behind the Rainbow</p>
                      </div>
                    </div>

                    {/*<div className="carousel-item">
                      <img className="d-block w-100" src={fotod} alt=""/>
                      <div class="carousel-caption d-none d-md-block text-light">
                        <h3 class="font-weight-bold text-left">...</h3>
                        <p class="text-left">,,,</p>                        
                      </div>
                    </div>*/}

                 </div>

                  <a className="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="sr-only">Previous</span>
                  </a>
                  <a className="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="sr-only">Next</span>
                  </a>

            </div>
        </div>

        <div className="text-dark col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-2 m-0 fontResponsive">
          <div className="">
            {/*<h2 className="card-title text-center"></h2>*/}
            <h5 className="card-title text-left">
            <br/>
            We offer guiding on established routes or we can deliver logistics for your dream climb. 
            </h5>
          </div>
        </div>

        <br/>
        <a href="/request_info" className="rounded-0 btn btn-lg btn-primary btn-block">Interested?</a>
        <br/>
        
        <div className="row m-0 p-0 justify-content-around">     
          <div className="border-0 text-light col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-2 m-0">
            <img className="img-fluid card-img rounded" src={fotod} alt=""/>
          </div>
        </div>

    </div>
  );
};

export default Climb;



// WEBPACK FOOTER //
// ./src/components/climb.jsx